export const sanidad = {
	nombre: "Sanidad",
	dia: "Martes Santo",
	nombrecompleto:
		"Venerable y Nacional Cofradía de Penitencia de Nuestro Padre Jesús del Mayor Dolor y María Santísima de la Salud",
	sede: "Parroquia de Santa Cruz",
	pasos: 2,
	distancia: [1020, 1720],
	penitentes: 170,
	cargadores: 112,
	web: "http://www.diariodecadiz.es/semana_santa/Sanidad_0_1229277811.html",

	ida: [
		// CATEDRAL
		{ lng: -6.2945746, lat: 36.5285578 },
		{ lng: -6.2946242, lat: 36.5285859 },
		{ lng: -6.2944928, lat: 36.5287583 },
		{ lng: -6.2942085, lat: 36.5288316 },
		{ lng: -6.2941065, lat: 36.5291506 },
		{ lng: -6.2938544, lat: 36.529129 },
		{ lng: -6.2938249, lat: 36.5292066 },
		{ lng: -6.2933032, lat: 36.5291214 },
		{ lng: -6.2932375, lat: 36.5293909 },
		{ lng: -6.2933931, lat: 36.5294189 },
		{ lng: -6.2933367, lat: 36.5297303 },
		{ lng: -6.2936117, lat: 36.5296948 },
		{ lng: -6.2936003, lat: 36.529858 },
		{ lng: -6.2936351, lat: 36.5300245 },
		{ lng: -6.2944472, lat: 36.5302271 },
		{ lng: -6.2943486, lat: 36.5305536 },
		{ lng: -6.2941166, lat: 36.5305693 },
		{ lng: -6.2935034, lat: 36.5307419 },
		{ lng: -6.2929232, lat: 36.5310804 },
		{ lng: -6.2922133, lat: 36.5302949 },
		{ lng: -6.292883, lat: 36.5297922 },
		{ lng: -6.2945294, lat: 36.5296271 },
		{ lng: -6.2947344, lat: 36.5294928 },
		{ lng: -6.2951453, lat: 36.5294257 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2957186, lat: 36.5290622 },
		{ lng: -6.2955281, lat: 36.5295385 },
		{ lng: -6.2954074, lat: 36.5297562 },
		{ lng: -6.2956676, lat: 36.5299588 },
		{ lng: -6.2952921, lat: 36.5303424 },
		{ lng: -6.2950225, lat: 36.5308338 },
		{ lng: -6.2949219, lat: 36.5308392 },
		{ lng: -6.2949246, lat: 36.5314524 },
		{ lng: -6.2964575, lat: 36.5317735 },
		{ lng: -6.2964079, lat: 36.5318425 },
		{ lng: -6.2966144, lat: 36.5322078 },
		{ lng: -6.2967914, lat: 36.5325397 },
		{ lng: -6.2964347, lat: 36.5329222 },
		{ lng: -6.2962738, lat: 36.5332455 },
		{ lng: -6.2963355, lat: 36.5332972 },
		{ lng: -6.2962711, lat: 36.5339373 },
		{ lng: -6.2960109, lat: 36.5339643 },
		{ lng: -6.2947322, lat: 36.5325397 },
		{ lng: -6.294364, lat: 36.5327261 },
		{ lng: -6.292174, lat: 36.5302993 },
		{ lng: -6.2928768, lat: 36.5297691 },
		{ lng: -6.2933139, lat: 36.5297325 },
		{ lng: -6.2933636, lat: 36.529435 },
		{ lng: -6.2932067, lat: 36.5294027 },
		{ lng: -6.2932871, lat: 36.5290988 },
		{ lng: -6.2938142, lat: 36.5291872 },
		{ lng: -6.2938397, lat: 36.5291107 },
		{ lng: -6.2940958, lat: 36.5291333 },
		{ lng: -6.2941998, lat: 36.5288197 },
		{ lng: -6.294475, lat: 36.5287459 },
		{ lng: -6.2945852, lat: 36.5286006 },
		{ lng: -6.2945572, lat: 36.5285815 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-27T16:45",
			latlng: [36.52857, -6.29444]
		},
		{
			name: "Nueva",
			hora: "2018-03-27T18:00",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-27T19:00",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-27T20:00",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-27T20:25",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-27T20:35",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Jesus de Medinaceli",
			"Plaza de Fray Félix",
			"Obispo José María Rancés",
			"Plaza de San Martín",
			"Posadilla",
			"San Antonio Abad",
			"Fabio Rufino",
			"Pomponio Mela",
			"Pelota",
			"Marqués de Cadiz",
			"Ruiz de Bustamante",
			"Cobos",
			"Cristóbal Colon",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena", "Valverde"],
		[
			"Beato Diego de Cadiz",
			"Rosario",
			"Marqués de Valdeiñigo",
			"San Francisco",
			"Plaza San Agustín",
			"San Francisco",
			"Nueva",
			"Plaza San Juan de Dios",
			"Pomponio Mela",
			"Fabio Rufino",
			"San Antonio Abad",
			"Posadilla",
			"Plaza de San Martín",
			"Obispo José María Rancés",
			"Plaza de Fray Félix",
			"Jesus de Medinaceli"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/sanidad.js